import React, { ReactElement } from 'react';
import { publicSessionApi } from '../../../../../redux/views/session-view/session/api/publicApi';
import { DemoHeaderTitle } from '.';

export type ConnectedPublicDemoHeaderTitleProps = {
  accessKey: string;
  sessionUid: string;
  versionUid: string;
};

export function ConnectedPublicDemoHeaderTitle({
  accessKey,
  sessionUid,
  versionUid,
}: ConnectedPublicDemoHeaderTitleProps): ReactElement {
  const { isError, isFetching, isLoading, demoTitle } =
    publicSessionApi.endpoints.getPublicSession.useQueryState(
      { accessKey, sessionUid, versionUid },
      {
        selectFromResult: ({ data, isFetching, isLoading, isError }) => ({
          demoTitle: data?.sessionDetails.name,
          isError,
          isFetching,
          isLoading,
        }),
      },
    );

  return (
    <DemoHeaderTitle
      demoTitle={demoTitle}
      isError={isError}
      isLoading={isLoading || isFetching}
    />
  );
}
